import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup,
  OAuthProvider,
  linkWithPopup,
} from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: process.env.NX_FIREBASE_KEY,
  authDomain: process.env.NX_FIREBASE_DOMAIN,
  projectId: process.env.NX_FIREBASE_PROJECT,
  storageBucket: process.env.NX_FIREBASE_BUCKET,
  messagingSenderId: process.env.NX_FIREBASE_SENDER,
  appId: process.env.NX_FIREBASE_APP,
  measurementId: process.env.NX_FIREBASE_MEASUREMENT,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export async function signInWithMicrosoft() {
  const provider = new OAuthProvider('microsoft.com');
  provider.setCustomParameters({ tenant: process.env.NX_AZURE_TENANT });

  provider.addScope('openid');
  provider.addScope('email');
  provider.addScope('profile');

  const result = await signInWithPopup(auth, provider);

  return result;
}

export async function linkMicrosoft() {
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in');

  const provider = new OAuthProvider('microsoft.com');
  provider.setCustomParameters({ tenant: process.env.NX_AZURE_TENANT });

  try {
    const result = await linkWithPopup(user, provider);
    await result.user.getIdToken(true);
  } catch (error) {
    return error.code;
  }
}

export const remoteConfig = getRemoteConfig(app);

export default app;
